var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#311B77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8341 1.88832H11.2785V1.11054C11.2785 0.682764 10.9285 0.332764 10.5008 0.332764H4.27854C3.85076 0.332764 3.50076 0.682764 3.50076 1.11054V1.88832H1.9452C1.08965 1.88832 0.389648 2.58832 0.389648 3.44387V4.22165C0.389648 6.20499 1.88298 7.82276 3.80409 8.06387C4.29409 9.23054 5.34409 10.1094 6.61187 10.3661V12.7772H4.27854C3.85076 12.7772 3.50076 13.1272 3.50076 13.555C3.50076 13.9828 3.85076 14.3328 4.27854 14.3328H10.5008C10.9285 14.3328 11.2785 13.9828 11.2785 13.555C11.2785 13.1272 10.9285 12.7772 10.5008 12.7772H8.16743V10.3661C9.4352 10.1094 10.4852 9.23054 10.9752 8.06387C12.8963 7.82276 14.3896 6.20499 14.3896 4.22165V3.44387C14.3896 2.58832 13.6896 1.88832 12.8341 1.88832ZM1.9452 4.22165V3.44387H3.50076V6.41499C2.59854 6.08832 1.9452 5.23276 1.9452 4.22165ZM12.8341 4.22165C12.8341 5.23276 12.1808 6.08832 11.2785 6.41499V3.44387H12.8341V4.22165Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.77e0bf77b9ebf7ad170848694465e5f0.svg";
export { ForwardRef as ReactComponent };